import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "lucide-react";

import { useLanguage } from "@/context/LanguageContext";

export default function FinancialShell({ title, subtitle, loading, children, t }) {
  const { lang } = useLanguage();
  const isRTL = lang === "ar";
  const align = isRTL ? "text-right" : "text-left";
  const BackIcon = isRTL ? ArrowRight : ArrowLeft;

  return (
    <div className="min-h-screen bg-[#f7f7f9] pt-24 pb-16 dark:bg-[#080808]">
      <div className="mx-auto max-w-5xl px-4 sm:px-6">
        <div className="mb-6 flex items-start gap-4 border-b border-black/8 pb-5 dark:border-white/10">
          <Link
            to="/financial"
            className="mt-1 flex h-10 w-10 items-center justify-center rounded-full border border-black/10 bg-white text-[#0a1628] hover:border-[#F37021]/30 dark:border-white/10 dark:bg-[#121212] dark:text-white"
            aria-label={t.back}
          >
            <BackIcon className="h-4 w-4" />
          </Link>
          <div className={`flex-1 ${align}`}>
            <p className="text-[11px] font-bold uppercase tracking-[0.22em] text-[#F37021]">{t.brand}</p>
            <h1 className="mt-1 text-2xl font-bold text-[#0a1628] dark:text-white sm:text-3xl">{title}</h1>
            {subtitle ? <p className="mt-1 text-sm text-[#667083] dark:text-[#BAC4D4]">{subtitle}</p> : null}
          </div>
        </div>
        {loading ? (
          <div className="flex justify-center py-20">
            <div className="h-10 w-10 animate-spin rounded-full border-4 border-[#F37021]/20 border-t-[#F37021]" />
          </div>
        ) : (
          children
        )}
      </div>
    </div>
  );
}
